// extracted by mini-css-extract-plugin
export default {"nav":"characteristic-nav_nav__Gevu+","active":"characteristic-nav_active__tS72r","delete":"characteristic-nav_delete__-ggIh"};